export default __webpack_public_path__ + "static/media/tool.ca9c3649.svg";